import * as React from "react";
import Svg, { G, Path, Defs, LinearGradient, Stop } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: filter */
const Whatsapp = (props : any) => (
    <Svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <G filter="url(#filter0_f_6259_14850)">
            <Path
                d="M7.46943 18.9277L7.77557 19.1087C9.06134 19.8703 10.5356 20.2732 12.039 20.2739H12.0422C16.6591 20.2739 20.4166 16.5245 20.4185 11.916C20.4193 9.68285 19.5489 7.58283 17.9674 6.00312C17.1917 5.22406 16.2689 4.60629 15.2524 4.18558C14.2359 3.76487 13.1459 3.54958 12.0455 3.55216C7.42492 3.55216 3.66731 7.3012 3.66567 11.9093C3.66339 13.4829 4.10736 15.025 4.94624 16.3573L5.14553 16.6733L4.29917 19.7573L7.46943 18.9277ZM1.87939 22.1464L3.30926 16.9358C2.42743 15.4109 1.9635 13.681 1.96404 11.9087C1.96637 6.36418 6.48706 1.85352 12.0423 1.85352C14.7381 1.85488 17.2684 2.90196 19.1714 4.80266C21.0744 6.70336 22.1214 9.22979 22.1204 11.9167C22.118 17.4608 17.5966 21.9723 12.0422 21.9723H12.0378C10.3512 21.9716 8.69398 21.5493 7.22192 20.7482L1.87939 22.1464Z"
                fill="#B3B3B3"
            />
        </G>
        <Path
            d="M1.776 22.0439L3.20587 16.8333C2.32251 15.3047 1.85852 13.5707 1.86065 11.8061C1.86298 6.26164 6.38366 1.75098 11.9389 1.75098C14.6347 1.75234 17.165 2.79942 19.068 4.70012C20.971 6.60082 22.018 9.12725 22.017 11.8142C22.0146 17.3582 17.4932 21.8697 11.9388 21.8697H11.9344C10.2478 21.869 8.59058 21.4467 7.11853 20.6456L1.776 22.0439Z"
            fill="white"
        />
        <Path
            d="M11.9419 3.44827C7.32139 3.44827 3.56379 7.19731 3.56214 11.8054C3.55987 13.379 4.00383 14.9211 4.84271 16.2534L5.04201 16.5696L4.19565 19.6535L7.36604 18.8238L7.67218 19.0048C8.95795 19.7664 10.4322 20.1692 11.9356 20.17H11.9388C16.5557 20.17 20.3134 16.4206 20.3151 11.8121C20.3186 10.7137 20.1038 9.62557 19.683 8.61061C19.2623 7.59565 18.644 6.67407 17.864 5.89923C17.0883 5.12015 16.1655 4.50237 15.1489 4.08166C14.1324 3.66095 13.0424 3.44567 11.9419 3.44827Z"
            fill="url(#paint0_linear_6259_14850)"
        />
        <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.41998 7.60218C9.23123 7.18371 9.03262 7.17523 8.85332 7.16799L8.37062 7.16211C8.20269 7.16211 7.92984 7.225 7.69918 7.47655C7.46851 7.7281 6.81775 8.33605 6.81775 9.57261C6.81775 10.8092 7.72013 12.004 7.84587 12.1719C7.97162 12.3398 9.58791 14.9582 12.1475 15.9657C14.2746 16.8029 14.7074 16.6364 15.1693 16.5945C15.6312 16.5527 16.6592 15.9866 16.8689 15.3997C17.0786 14.8128 17.0787 14.3099 17.0159 14.2048C16.953 14.0997 16.7851 14.0372 16.533 13.9114C16.281 13.7857 15.0432 13.1777 14.8124 13.0938C14.5816 13.0098 14.4138 12.9681 14.2457 13.2197C14.0776 13.4712 13.5956 14.0371 13.4487 14.2048C13.3017 14.3726 13.155 14.3936 12.9029 14.268C12.6509 14.1423 11.84 13.8768 10.8779 13.0206C10.1294 12.3544 9.62407 11.5317 9.47696 11.2803C9.32985 11.0289 9.46134 10.8927 9.58763 10.7675C9.70064 10.6548 9.83939 10.4739 9.96554 10.3273C10.0917 10.1806 10.1332 10.0757 10.217 9.90824C10.3009 9.74076 10.2591 9.59366 10.1961 9.46802C10.1331 9.34239 9.64379 8.0994 9.41998 7.60232"
            fill="white"
        />
        <Defs>
            <LinearGradient
                id="paint0_linear_6259_14850"
                x1={11.7681}
                y1={4.45173}
                x2={11.8527}
                y2={18.7415}
                gradientUnits="userSpaceOnUse"
            >
                <Stop stopColor="#57D163" />
                <Stop offset={1} stopColor="#23B33A" />
            </LinearGradient>
        </Defs>
    </Svg>
);
export default Whatsapp;
